module.exports = __webpack_public_path__ + "static/media/top_shape_7_mob.e6540bbd.svg";